import comp from "./QuestionPane";
export default comp;
